import React from "react";
import { Search } from "lucide-react";
import { getFormattedDate } from "../../utils/formatDate";
import NotificationBell from "./NotificationBell";

const Header = ({
  currentView = "dashboard",
  displayName = "",
  onNotificationsClick,
  onSearchClick,
}) => {
  if (currentView !== "dashboard") {
    return null;
  }

  return (
    <div className="bg-gray-50 px-4 py-4 sm:px-8 sm:py-6 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            {getFormattedDate()}
          </h1>
          <p className="text-lg text-gray-600">
            Bienvenido de vuelta, {displayName || "Atleta"}
          </p>
        </div>
        <div className="hidden lg:flex items-center gap-2">
          {onSearchClick && (
            <button
              type="button"
              onClick={onSearchClick}
              data-analytics-id="header-search"
              className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
              aria-label="Buscar atletas"
            >
              <Search size={20} className="text-gray-700" />
            </button>
          )}
          {onNotificationsClick && (
            <NotificationBell onClick={onNotificationsClick} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
